import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Typography, Space, Input, Row, Col } from 'antd';
import { Redirect } from 'react-router-dom';

import { CommonFormProps, OnboardingLayout } from '.';
import { createPath } from '~/pages/onboarding/Sider';
import { BackButton, Form } from '~/components';
import { useOnboardingPage, useOnboardingState } from '~/hooks/onboarding';
import { phoneValidation } from '~/utils';
import PhoneInput from '~/components/PhoneInput';

const { Title, Text } = Typography;

const CompanyContacts: FC<CommonFormProps> = (props) => {
  const { name } = props;
  const { t } = useTranslation('onboarding');
  const dt = (key: string): string => t(`translation:${key}`);
  const [form] = Form.useForm();
  const onboardingPage = useOnboardingPage(name);

  const [pageState, setPageState] = useOnboardingState(name);
  const [personalInfoState] = useOnboardingState('personalInfo');

  const onFinish = (values: any) => {
    setPageState((prev) => ({
      ...prev,
      formData: values,
    }));
    onboardingPage.activateNext();
    onboardingPage.goNext();
  };

  return (
    <OnboardingLayout>
      {pageState.skip && <Redirect to={createPath('personalInfo')} />}
      <Title level={2}>{t('Company contacts')}</Title>
      <Space size="middle" direction="vertical">
        <Text>{t('Please fill company contacts')}</Text>
        <Form
          form={form}
          name={name}
          initialValues={pageState.formData || { PHONE: personalInfoState.formData?.phoneNumber }}
          layout="vertical"
          size="large"
          onFinish={onFinish}
        >
          <Form.Item name="PHONE" rules={[{ required: true, validator: phoneValidation }]}>
            <PhoneInput placeholder={t('Company phone number')} />
          </Form.Item>
          <Form.Item name="EMAIL" rules={[{ required: true, type: 'email' }]}>
            <Input placeholder={t('Company email')} />
          </Form.Item>
          <Row gutter={16}>
            <Col>
              <BackButton onClick={onboardingPage.goBack} />
            </Col>
            <Col>
              <Form.Item noStyle>
                <Button type="primary" htmlType="submit">
                  {dt('continue')}
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Space>
    </OnboardingLayout>
  );
};

export default CompanyContacts;
